import { Session } from '@ais-ui/auth';

export const changePassword = async (
  session: Session,
  username: string,
  oldPassword: string,
  newPassword: string,
) => {
  const response = await session.request('changePassword', {
    userName: username,
    oldPassword,
    newPassword,
  });

  return response;
};
